/* @flow */
import React from 'react';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeForm from 'forms/_.extend';

import ElectroSelectWithOther from 'forms/components/inputs/ElectroSelectWithOther/ElectroSelectWithOther';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  t: TranslatorProps,
  account: Object,
  user: Object,
  form: TypeForm,
};

@translate()
@observer
export default class RevokeAccessForm extends React.Component<*> {
  render(): React.Fragment {
    const { t, user, account, form }: TypeProps = this.props;

    const detailsAccount: Array<Array> = [
      [t('general:trading_account'), account.name],
      [t('general:trading_accounts.labels.number'), account.account_no],
    ];

    const detailsUser: Array<Array> = [
      [t('general:trading_account'), `${account.name} ${account.account_no}`],
      [t('general:name'), `${user.first_name} ${user.last_name}`],
      [t('general:roles.labels.current_role'), t(`general:roles.${user.role_id}`)],
    ];

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:users.labels.details')}
          >
            <ActionDrawerTable data={detailsUser} />
          </ActionDrawerBlock>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:users.access_removed_from')}
          >
            <ActionDrawerTable data={detailsAccount} />
          </ActionDrawerBlock>
          <ActionDrawerBlock gutters={true} heading={form.$('removeReason').label}>
            <ElectroSelectWithOther
              field={form.$('removeReason.reason')}
              otherHeading={`${t('general:reasons.provide_reason')} *`}
            />
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.revoke_access')} />
      </React.Fragment>
    );
  }
}
